"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactGa = _interopRequireDefault(require("react-ga"));
var _axios = _interopRequireDefault(require("axios"));
var _intlTelInput = _interopRequireDefault(require("intl-tel-input"));
var _utils = _interopRequireDefault(require("intl-tel-input/build/js/utils"));
var _querystring = _interopRequireDefault(require("querystring"));
var _sweetalert = _interopRequireDefault(require("sweetalert"));
var _reactstrap = require("reactstrap");
var _formValidation2 = require("./util/formValidation");
var _mailchimp = require("./util/mailchimp");
var _getDevice = require("./util/getDevice");
var _upload = require("./util/upload");
var _helper = require("./util/helper");
var _SubmissionTerms = _interopRequireDefault(require("./SubmissionTerms"));
var _SubmissionThankYou = _interopRequireDefault(require("./SubmissionThankYou"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var windowGlobal = typeof window !== "undefined" && window;
var SubmissionForm = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SubmissionForm, _React$PureComponent);
  var _super = _createSuper(SubmissionForm);
  function SubmissionForm() {
    var _this;
    _classCallCheck(this, SubmissionForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      modal: false,
      isTerms: false,
      isMobile: false,
      url: "",
      first_name: "",
      last_name: "",
      email: "",
      country: "",
      countries: [],
      utm: {
        utmCampaign: null,
        utmSource: null,
        utmMedium: null,
        utmContent: null
      }
    });
    _defineProperty(_assertThisInitialized(_this), "intil", void 0);
    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var riffUrl = _this.props.riffUrl;
      var input = document.querySelector("#phone");
      _this.intil = (0, _intlTelInput["default"])(input, {
        separateDialCode: true,
        utilsScript: _utils["default"]
      });
      _this.getCountry(riffUrl);
      _this.setState({
        isMobile: (0, _helper.detectIsMobile)(),
        utm: (0, _helper.getUTM)()
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getCountry", function (riffUrl) {
      _axios["default"].get("".concat(riffUrl, "/api/public/countries/all")).then(function (response) {
        _this.setState({
          countries: response.data
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (event, submissionSource, riffUrl, mailchimpUrl, mailchimpListID) {
      var isNewsletterSignUpRequired = _this.props.isNewsletterSignUpRequired;
      event.preventDefault();
      var age = document.querySelector("#age").checked;
      var agreeTerms = document.querySelector("#agreeTerms").checked;
      var videoUrl = document.querySelector("#url").value.replace(/\s/g, "");
      var newsletterSignUp = isNewsletterSignUpRequired && document.querySelector("#newsletterSignUp").checked;
      var firstName = document.querySelector("#first_name").value.trim();
      var lastName = document.querySelector("#last_name").value.trim();
      var emailInput = document.querySelector("#email").value.trim();
      var country = document.querySelector("#country").value;
      var _formValidation = (0, _formValidation2.formValidation)(event, _this.state.isMobile),
        errors = _formValidation.errors,
        errorsString = _formValidation.errorsString;
      if (errors) {
        (0, _sweetalert["default"])({
          title: "Oops...",
          text: errorsString,
          className: "sweet-center",
          icon: "error"
        });
        return false;
      } else {
        document.querySelector("#newSubmission").disabled = true;
        document.querySelector(".loader").classList.remove("d-none");
        var data = {
          firstName: firstName,
          lastName: lastName,
          videoUrl: videoUrl,
          email: emailInput,
          countryCode: country,
          bucketName: windowGlobal.Upload.fileName ? _upload.bucketName : null,
          fileKey: windowGlobal.Upload.fileName,
          phone: _this.intil.getNumber(),
          isEuCitizen: document.querySelector("#eu").checked,
          acceptServiceTerms: agreeTerms,
          acceptSubmissionTerms: agreeTerms,
          thirteenYears: age,
          newsletterSubscription: newsletterSignUp,
          source: submissionSource,
          isOwner: document.querySelector("#is_owner").checked,
          campaignCode: _this.state.utm.utmCampaign !== null ? _this.state.utm.utmCampaign.slice(0, 255) : "",
          campaignSource: _this.state.utm.utmSource !== null ? _this.state.utm.utmSource.slice(0, 255) : "",
          campaignMedium: _this.state.utm.utmMedium !== null ? _this.state.utm.utmMedium.slice(0, 255) : "",
          campaignContent: _this.state.utm.utmContent !== null ? _this.state.utm.utmContent.slice(0, 255) : "",
          campaignPlatform: (0, _getDevice.getDevice)().device
        };
        var submissionType = windowGlobal.Upload.fileName ? "File Upload" : "Video Url";
        var config = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          }
        };
        if (newsletterSignUp) {
          (0, _mailchimp.mailchimp)({
            email_address: emailInput,
            status: "subscribed",
            merge_fields: {
              FNAME: firstName,
              LNAME: lastName
            },
            tags: ["SUBMISSION"]
          }, document.querySelector("#jukin-submission-form"), mailchimpUrl, mailchimpListID);
          _reactGa["default"].ga("send", "event", "Submission", "Newsletter Sign Up", submissionType);
        }
        _axios["default"].post("".concat(riffUrl, "/api/public/submission"), _querystring["default"].stringify(data), config).then(function (data) {
          _reactGa["default"].ga("send", "event", "Submission", "Successful", submissionType);
          document.querySelector("#newSubmission").disabled = false;
          document.querySelector(".loader").classList.add("d-none");
          document.getElementById("jukin-submission-form").reset();
          _this.setState({
            isTerms: false
          });
          _this.toggle();
          if (_this.state.isMobile) {
            var methodSelect = document.getElementById("method-select");
            methodSelect.options[0].selected = true;
            (0, _upload.handleSelect)();
          }
        })["catch"](function (error) {
          var errorMessage = "";
          if (error.response) {
            errorMessage = error.response.data.messages[0];
          } else if (error.request) {
            errorMessage = error.request;
          } else {
            errorMessage = error.message;
          }
          var swalMessage = document.createElement("div");
          swalMessage.innerHTML = "<h4 style='text-align:left; font-size: 18px; font-weight: 400'>There was a problem with your submission. Here's why you might be receiving this message:</h4><ul><li style='text-align:left'>You might have already submitted your video to one of Jukin's other brands or submission websites. If this is the case, we're already reviewing it!</li><li style='text-align:left'>Someone else may have submitted your video. Have no fear; our research staff always finds and contacts a video's rightful owner.</li><li style='text-align:left'>You may be trying to submit a URL type that our system doesn't recognize.</li></ul><p style='text-align:left'>If you don't think your situation is described above, please email <a href='mailto:videosubmissions@jukinmedia.com'>videosubmissions@jukinmedia.com</a> for assistance.</p>";
          (0, _sweetalert["default"])({
            title: "",
            content: swalMessage,
            className: "sweet-center",
            icon: "error"
          });
          document.querySelector("#newSubmission").disabled = false;
          document.querySelector(".loader").classList.add("d-none");
          _reactGa["default"].ga("send", "event", "Submission", "Failed", errorMessage);
        });
      }
    });
    return _this;
  }
  _createClass(SubmissionForm, [{
    key: "updateField",
    value: function updateField(event) {
      var name = event.target.name;
      var value = event.target.value;
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        mailchimpUrl = _this$props.mailchimpUrl,
        mailchimpListID = _this$props.mailchimpListID,
        riffUrl = _this$props.riffUrl,
        site = _this$props.site,
        submissionSource = _this$props.submissionSource,
        tos = _this$props.tos,
        typeform = _this$props.typeform,
        uploadPrefix = _this$props.uploadPrefix,
        isNewsletterSignUpRequired = _this$props.isNewsletterSignUpRequired;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: function onSubmit(e) {
          return _this2.onSubmit(e, submissionSource, riffUrl, mailchimpUrl, mailchimpListID);
        },
        id: "jukin-submission-form"
      }, this.state.isMobile ? /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 selector mobile-selector"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "sr-only",
        htmlFor: "method-select"
      }), /*#__PURE__*/_react["default"].createElement("select", {
        id: "method-select",
        onChange: _upload.handleSelect
      }, /*#__PURE__*/_react["default"].createElement("option", {
        defaultValue: ""
      }, "Choose One..."), /*#__PURE__*/_react["default"].createElement("option", {
        value: "upload"
      }, "Upload Video"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "url"
      }, "Provide Link")))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "url-form",
        className: "row d-none"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "url"
      }, "Video Url *"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        id: "url",
        maxLength: "1024",
        name: "url",
        onChange: function onChange(event) {
          return _this2.updateField(event);
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "upload-form",
        className: "row d-none"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "url"
      }, "Upload Your Video ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "astrick"
      }, "*")), /*#__PURE__*/_react["default"].createElement("input", {
        className: "d-none",
        type: "file",
        id: "upload",
        name: "file-upload",
        accept: "video/*",
        onChange: function onChange(event) {
          return (0, _upload.handleFiles)(event.target.files, uploadPrefix);
        }
      }), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-xs btn-select-file",
        type: "button",
        onClick: function onClick() {
          return (0, _upload.clickSelectFile)();
        }
      }, "Select File"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "upload-message",
        className: "text-center d-none"
      }, "Upload Complete"), /*#__PURE__*/_react["default"].createElement("div", {
        id: "upload-progress",
        className: "progress d-none"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "progress-bar",
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, "0%"))))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "url"
      }, "Video Url *"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        id: "url",
        maxLength: "1024",
        name: "url",
        onChange: function onChange(event) {
          return _this2.updateField(event);
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 col-md-6"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "first_name"
      }, "First Name *"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        id: "first_name",
        maxLength: "56",
        name: "firs_name",
        onKeyDown: function onKeyDown(event) {
          return (0, _helper.alphaOnly)(event);
        },
        onChange: function onChange(event) {
          return _this2.updateField(event);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 col-md-6"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "last_name"
      }, "Last Name *"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        id: "last_name",
        maxLength: "56",
        name: "last_name",
        onKeyDown: function onKeyDown(event) {
          return (0, _helper.alphaOnly)(event);
        },
        onChange: function onChange(event) {
          return _this2.updateField(event);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 col-md-6"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "email"
      }, "Email *"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        id: "email",
        maxLength: "128",
        name: "email",
        onChange: function onChange(event) {
          return _this2.updateField(event);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 col-md-6 phone-container"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "phone"
      }, "Phone *"), /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        id: "phone",
        maxLength: "27"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 selector"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "country"
      }, "Country *"), /*#__PURE__*/_react["default"].createElement("select", {
        id: "country",
        name: "country",
        onChange: function onChange(event) {
          return _this2.updateField(event);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "",
        defaultValue: true,
        className: "colored"
      }, "Please Select Country *"), this.state.countries.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          value: item.code,
          key: String(index),
          className: "colored"
        }, item.name);
      })))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-12 checker"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearer"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        id: "is_owner",
        value: "owner"
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "is_owner"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "I was holding the camera to record this video! No one else helped me create the video."))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearer"
      }), isNewsletterSignUpRequired && /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        id: "newsletterSignUp"
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "newsletterSignUp"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Sign me up for the newsletter."))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearer"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        id: "eu"
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "eu"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "I am an EU citizen and/or reside in the EU."))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearer"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        id: "agreeTerms"
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "agreeTerms"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "I have read and agree to the", " ", /*#__PURE__*/_react["default"].createElement("a", {
        className: "underline",
        onClick: function onClick() {
          return _reactGa["default"].ga("send", "event", "Submission", "Terms of Service");
        },
        href: tos,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Terms of Service"), " ", "and", " ", /*#__PURE__*/_react["default"].createElement("a", {
        className: "underline",
        onClick: function onClick() {
          _this2.setState({
            isTerms: true
          });
          _this2.toggle();
          _reactGa["default"].ga("send", "event", "Submission", "Terms of Submission");
        }
      }, "Terms of Submission"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "astrick"
      }, "*")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearer"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        id: "age"
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: "age"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "I am 13 years of age or older.", " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "astrick"
      }, "*")))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "submit",
        className: "fa-button black-button",
        id: "newSubmission"
      }, "Submit video", /*#__PURE__*/_react["default"].createElement("div", {
        className: "loader d-none"
      }))))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
        isOpen: this.state.modal,
        toggle: this.toggle,
        className: this.state.isTerms ? "terms-modal" : "thank-you-modal"
      }, this.state.isTerms && /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/_react["default"].createElement("h4", null, site, " Terms of Submission")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-body"
      }, this.state.isTerms ? /*#__PURE__*/_react["default"].createElement(_SubmissionTerms["default"], {
        site: site
      }) : /*#__PURE__*/_react["default"].createElement(_SubmissionThankYou["default"], {
        typeform: typeform
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-footer"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        color: "secondary",
        onClick: this.toggle
      }, "Close"))));
    }
  }]);
  return SubmissionForm;
}(_react["default"].PureComponent);
exports["default"] = SubmissionForm;